import { render, staticRenderFns } from "./CircleAlert.vue?vue&type=template&id=212a5b9e"
import script from "./CircleAlert.vue?vue&type=script&lang=js"
export * from "./CircleAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports